import { useShouldWaitForClientApproval } from "@/hooks/useShouldWaitForClientApproval";
import type { InvoiceTypeString } from "@/lib/constants/invoice-type";
import { useTenant } from "@/providers/session";
import { gql, useQuery } from "@apollo/client";

export const useGetInvoiceExportGroups = ({
  invoiceIds,
  exportAll,
  groupBy,
  fetchPolicy = "network-only",
  invoiceType,
}: {
  invoiceIds: string[];
  exportAll: boolean;
  groupBy: "invoiceDate" | "serviceDate";
  fetchPolicy?: "network-only";
  invoiceType?: InvoiceTypeString;
}) => {
  const { tenantId } = useTenant();
  const shouldWaitForClientApproval = useShouldWaitForClientApproval();

  const { data, error, loading, refetch } = useQuery<{
    invoiceExportGroups: Record<string, string[]>;
  }>(INVOICE_EXPORT_GROUPS_QUERY, {
    variables: { tenantId, invoiceIds, exportAll, groupBy, invoiceType },
    fetchPolicy,
  });

  return {
    invoiceExportGroups: data?.invoiceExportGroups?.groupedInvoices ?? {},
    hasPendingClientApproval:
      shouldWaitForClientApproval &&
      data?.invoiceExportGroups?.hasPendingClientApproval,
    hasMissingDates: data?.invoiceExportGroups?.hasMissingDates ?? false,
    error,
    loading,
    refetch,
  };
};

export const INVOICE_EXPORT_GROUPS_QUERY = gql`
  query InvoiceExportGroups(
    $invoiceIds: [String]
    $tenantId: String
    $exportAll: Boolean
    $groupBy: String
    $invoiceType: String
  ) {
    invoiceExportGroups(
      invoiceIds: $invoiceIds
      tenantId: $tenantId
      exportAll: $exportAll
      groupBy: $groupBy
      invoiceType: $invoiceType
    )
  }
`;
